import React, { useEffect, useState } from "react";
import { FloppyDisk } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../../lib/api";

export default function AdminContent() {
  const [c, setC] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/site-content").then(({ data }) => setC(data));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/admin/site-content", c);
      toast.success("Content updated");
    } catch {
      toast.error("Save failed");
    } finally {
      setSaving(false);
    }
  };

  if (!c) return <div className="text-[#5C7368]">Loading...</div>;

  const upd = (k, v) => setC({ ...c, [k]: v });

  return (
    <form onSubmit={save} data-testid="admin-content" className="max-w-3xl">
      <div className="mb-6">
        <h1 className="h2 text-[#0A1F15]">Site Content</h1>
        <p className="text-[#5C7368]">Edit homepage, about, contact content & section visibility.</p>
      </div>

      <Section title="Homepage Hero">
        <F label="Hero Headline"><input value={c.hero_headline} onChange={e => upd("hero_headline", e.target.value)} className="inp"/></F>
        <F label="Hero Subheadline"><textarea rows={2} value={c.hero_subheadline} onChange={e => upd("hero_subheadline", e.target.value)} className="inp resize-none"/></F>
        <div className="grid md:grid-cols-2 gap-3">
          <F label="Primary CTA"><input value={c.hero_cta_primary} onChange={e => upd("hero_cta_primary", e.target.value)} className="inp"/></F>
          <F label="Secondary CTA"><input value={c.hero_cta_secondary} onChange={e => upd("hero_cta_secondary", e.target.value)} className="inp"/></F>
        </div>
      </Section>

      <Section title="Stats">
        <div className="grid md:grid-cols-4 gap-3">
          <F label="Projects"><input value={c.stat_projects} onChange={e => upd("stat_projects", e.target.value)} className="inp"/></F>
          <F label="Savings"><input value={c.stat_savings} onChange={e => upd("stat_savings", e.target.value)} className="inp"/></F>
          <F label="Satisfaction"><input value={c.stat_satisfaction} onChange={e => upd("stat_satisfaction", e.target.value)} className="inp"/></F>
          <F label="Experience"><input value={c.stat_experience} onChange={e => upd("stat_experience", e.target.value)} className="inp"/></F>
        </div>
      </Section>

      <Section title="About">
        <F label="Intro"><textarea rows={3} value={c.about_intro} onChange={e => upd("about_intro", e.target.value)} className="inp resize-none"/></F>
        <F label="Mission"><textarea rows={3} value={c.about_mission} onChange={e => upd("about_mission", e.target.value)} className="inp resize-none"/></F>
        <F label="Vision"><textarea rows={3} value={c.about_vision} onChange={e => upd("about_vision", e.target.value)} className="inp resize-none"/></F>
      </Section>

      <Section title="Contact Details">
        <div className="grid md:grid-cols-2 gap-3">
          <F label="Primary Phone"><input value={c.phone_primary} onChange={e => upd("phone_primary", e.target.value)} className="inp"/></F>
          <F label="Secondary Phone"><input value={c.phone_secondary} onChange={e => upd("phone_secondary", e.target.value)} className="inp"/></F>
          <F label="Email"><input value={c.email} onChange={e => upd("email", e.target.value)} className="inp"/></F>
          <F label="WhatsApp"><input value={c.whatsapp} onChange={e => upd("whatsapp", e.target.value)} className="inp"/></F>
        </div>
        <F label="Address"><input value={c.address} onChange={e => upd("address", e.target.value)} className="inp"/></F>
      </Section>

      <Section title="Section Visibility (Home)">
        <div className="grid md:grid-cols-2 gap-3">
          {["show_stats", "show_why_us", "show_process", "show_testimonials", "show_projects", "show_blog"].map(k => (
            <label key={k} className="flex items-center gap-2 p-3 rounded-xl border border-[#E5E3DB] cursor-pointer hover:bg-[#F9F8F6]">
              <input type="checkbox" checked={!!c[k]} onChange={e => upd(k, e.target.checked)}/>
              <span className="capitalize">{k.replace("show_", "").replace(/_/g, " ")}</span>
            </label>
          ))}
        </div>
      </Section>

      <button type="submit" disabled={saving} className="btn-primary mt-4 disabled:opacity-60">
        <FloppyDisk weight="bold" size={18}/> {saving ? "Saving..." : "Save Changes"}
      </button>

      <style>{`.inp{width:100%;padding:0.75rem 1rem;border-radius:0.75rem;border:1px solid #E5E3DB;background:white;} .inp:focus{outline:none;border-color:#0F52BA;}`}</style>
    </form>
  );
}

function Section({ title, children }) {
  return (
    <div className="bg-white rounded-2xl p-6 border border-[#E5E3DB] mb-4">
      <h3 className="h3 mb-4">{title}</h3>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

function F({ label, children }) {
  return (
    <div>
      <label className="block text-xs font-bold uppercase tracking-wider text-[#5C7368] mb-1.5">{label}</label>
      {children}
    </div>
  );
}
